/* Mesmerize · Journal · mes-journal.js (no dependencies)
   Loaded only when the dateline is set to today's date. Replaces the server-rendered fallback (the cover story's
   date) with today's date in en-IN long form, e.g. "Wednesday, 7 October 2026". */
(function () {
  'use strict';
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function fill(scope) {
    var els = (scope || document).querySelectorAll('[data-mjr-today]');
    if (!els.length) return;
    var d = new Date(), s;
    try {
      var p = {};
      new Intl.DateTimeFormat('en-IN', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })
        .formatToParts(d).forEach(function (x) { p[x.type] = x.value; });
      s = p.weekday + ', ' + p.day + ' ' + p.month + ' ' + p.year;
    } catch (e) { return; }
    var iso = d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
    Array.prototype.forEach.call(els, function (el) { el.textContent = s; el.setAttribute('datetime', iso); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { fill(); }); else fill();
  document.addEventListener('shopify:section:load', function (e) { fill(e.target); });
})();
